/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Left_Center_Justify_Left_PosInputs */

const en_align_left_center_justify_left_pos = /** @type {(inputs: Align_Left_Center_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Center Justify / Left Position`)
};

const fr_align_left_center_justify_left_pos = /** @type {(inputs: Align_Left_Center_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justification Centree / Position Gauche`)
};

const de_align_left_center_justify_left_pos = /** @type {(inputs: Align_Left_Center_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zentriert / Linksposition`)
};

const it_align_left_center_justify_left_pos = /** @type {(inputs: Align_Left_Center_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allineamento al centro / Posizione a sinistra`)
};

const ru_align_left_center_justify_left_pos = /** @type {(inputs: Align_Left_Center_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выравнивание по центру / Позиция слева`)
};

const es_align_left_center_justify_left_pos = /** @type {(inputs: Align_Left_Center_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justificación al centro / Posición izquierda`)
};

const zh_cn2_align_left_center_justify_left_pos = /** @type {(inputs: Align_Left_Center_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`居中对齐/左对齐`)
};

const ja_align_left_center_justify_left_pos = /** @type {(inputs: Align_Left_Center_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中央揃え / 左揃え`)
};

const hi_align_left_center_justify_left_pos = /** @type {(inputs: Align_Left_Center_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केंद्र संरेखित करें / बाएँ ओर स्थित करें`)
};

const pt_pt2_align_left_center_justify_left_pos = /** @type {(inputs: Align_Left_Center_Justify_Left_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centralizado / Posicionamento à esquerda`)
};

/**
* | output |
* | --- |
* | "Center Justify / Left Position" |
*
* @param {Align_Left_Center_Justify_Left_PosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_left_center_justify_left_pos = /** @type {((inputs?: Align_Left_Center_Justify_Left_PosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Left_Center_Justify_Left_PosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_align_left_center_justify_left_pos(inputs)
	if (locale === "de") return de_align_left_center_justify_left_pos(inputs)
	if (locale === "it") return it_align_left_center_justify_left_pos(inputs)
	if (locale === "ru") return ru_align_left_center_justify_left_pos(inputs)
	if (locale === "es") return es_align_left_center_justify_left_pos(inputs)
	if (locale === "zh-CN") return zh_cn2_align_left_center_justify_left_pos(inputs)
	if (locale === "ja") return ja_align_left_center_justify_left_pos(inputs)
	if (locale === "hi") return hi_align_left_center_justify_left_pos(inputs)
	if (locale === "pt-PT") return pt_pt2_align_left_center_justify_left_pos(inputs)
	return en_align_left_center_justify_left_pos(inputs)
});